import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Work from "@/components/sections/Work";
import About from "@/components/sections/About";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-[#0a0a0f] text-white font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <Problem />
      <Services />
      <Process />
      <Work />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
